import queryString from 'querystring';
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('FACETTE_SUGGESTION').plugin(axiosPlugin, {template: "array"});
let fetchAction = redux.fetchActionGet();


export const TYPES = redux.types;

export const fetchFacetteSuggestion = (facetteId,query = {}) => fetchAction(`/facettes/${facetteId}/suggestion?${queryString.stringify(query)}`);
export const resetFacetteSuggestion = () => redux.actions.reset();

export const facetteSuggestion = redux.reducer();
